
import { defineComponent, PropType } from "vue";
import Dataset from "./dataset.vue";
import { IDatasetDocument } from "@/types/dataset";
import {
	CollarDrillholeLayerConfigType,
	NonDrillholeLayerConfigType
} from "@/utils/DisplayPaneConstants";
export default defineComponent({
	name: "imdex-dataset",
	setup() {
		return {};
	},
	components: {
		Dataset
	},
	props: {
		children: {
			// will always be an empty array currently. in the future should be filled to support multiple levels of depth
			type: Array as PropType<any[]>,
			default: () => [] as any[]
		},
		name: {
			type: String,
			default: "ROOT"
		},
		groupName: {
			type: String,
			default: ""
		},
		dataType: {
			type: String,
			default: ""
		},
		selected: {
			type: Object as PropType<string[]>,
			default: () => [] as string[]
		},
		highlighted: {
			type: Object as PropType<string[]>,
			default: () => [] as string[]
		},
		searchTerm: {
			type: String,
			default: ""
		},
		datasets: {
			type: Array as () => IDatasetDocument[],
			required: true
		},
		latestUploadedDatasetId: {
			type: String,
			default: ""
		},
		latestUploadedDatasetFolderPath: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			isExpanded: false,
			showMenu: false,
			selectType: "on",
			closeOptionsMenuListener: null as any,
			drillhole: require("@/assets/svg/hole_type2.svg"),
			blockmodel: require("@/assets/svg/bm_type.svg"),
			shape: require("@/assets/svg/polygon_type.svg"),
			renaming: false,
			newName: this.name,
			showFolderNameTruncatedTooltip: false,
			NonDrillholeLayerConfigTypeTmp: NonDrillholeLayerConfigType,
			CollarDrillholeLayerConfigTypeTmp: CollarDrillholeLayerConfigType
		};
	},
	mounted() {
		this.drawDashedBorders();

		if (this.name == this.latestUploadedDatasetFolderPath) {
			for (let i = 0; i < this.datasets.length; i++) {
				if (this.datasets[i].id == this.latestUploadedDatasetId) {
					this.isExpanded = true;
					break;
				}
			}
		}
	},
	beforeUnmount() {
		if ((this.$refs as any).showMenu) {
			this.toggleShowMenu("remove");
		}
	},
	computed: {},
	methods: {
		drawDashedBorders() {
			this.$nextTick(() => {
				const el: HTMLDivElement = this.$refs["folder-name"] as HTMLDivElement;
				if (el != null) {
					for (const child of el.children) {
						if (child.classList.contains("dashed-hierarchy-border")) {
							el.removeChild(child);
						}
					}
				}
				const dashedBorderEl = document.createElement("div");
				dashedBorderEl.classList.add("dashed-hierarchy-border");
				if (this.datasets.length == 0) {
					dashedBorderEl.style.width = "25px";
				} else {
					dashedBorderEl.style.width = "8px";
				}
				if (el != null) {
					el.appendChild(dashedBorderEl);
				}
				if (this.searchTerm.length > 0) {
					this.isExpanded = true;
				}
			});
		},
		toggleRename() {
			this.renaming = true;
			this.$nextTick(() => {
				(this.$refs as any).renameInput.focus();
			});
		},
		toggleShowMenu(type?: string, e?: any) {
			this.emitSetActiveDatasetType();
			this.emitSetActiveGroup();
			if (type == "right") {
				const [y, x] = [e.pageY, e.pageX];
				this.showMenu = !this.showMenu;
				this.$nextTick(() => {
					if (this.showMenu) {
						// const {top, left} = (this.$refs as any).showMenuIcon.getBoundingClientRect();
						const body = document.getElementsByTagName("body")[0];
						(this.$refs as any).showMenu.style.top = y + 5 + "px";
						(this.$refs as any).showMenu.style.left = x + "px";
						body.appendChild((this.$refs as any).showMenu);
					}
				});
			} else if (type === "remove") {
				const body = document.getElementsByTagName("body")[0];
				body.removeChild((this.$refs as any).showMenu);
			} else {
				this.showMenu = !this.showMenu;
				this.$nextTick(() => {
					if (this.showMenu) {
						const { top, left } = (
							this.$refs as any
						).showMenuIcon.getBoundingClientRect();
						const body = document.getElementsByTagName("body")[0];
						(this.$refs as any).showMenu.style.top = top + 20 + "px";
						(this.$refs as any).showMenu.style.left = left + "px";

						body.appendChild((this.$refs as any).showMenu);
					}
				});
			}
		},
		closeRenameInput() {
			this.renaming = false;
		},
		// These act directly the this component
		emitRenameFolder() {
			if (!this.newName || !this.newName.trim()) this.newName = this.name; // if empty, reassign to old name as we'll ignore the input regardless
			this.$emit("renameFolder", {
				newFolderPath: this.newName,
				folderPath: this.name,
				datasetType: this.dataType
			});
			this.renaming = false;
		},
		emitImportIntoFolder(name: string) {
			this.$emit("importIntoFolder", name);
		},
		highlight(text: any) {
			this.$nextTick(() => {
				let innerHTML =
					this.name.toLowerCase().charAt(0) + this.name.toLowerCase().slice(1);
				const index = innerHTML.indexOf(text.toLowerCase());
				if (index >= 0) {
					this.$nextTick(async () => {
						const inputText: any = this.$refs["folderName"];
						if (innerHTML == null) return;
						if (inputText == null) return;
						innerHTML =
							innerHTML.substring(0, index) +
							`<span class='highlight'>` +
							innerHTML.substring(index, index + text.length) +
							"</span>" +
							innerHTML.substring(index + text.length);
						inputText.innerHTML = innerHTML;
					});
				}
			});
		},
		// All of the below are implemented in dataset.vue and these just pass data from <Dataset>
		emitSetDefaultMoveGroup() {
			this.$emit("setDefaultMoveGroup", this.groupName);
		},
		emitDeleteDataset(data: any) {
			this.$emit("deleteDataset", data);
		},
		emitDeleteFolder(data: any) {
			this.$emit("deleteFolder", data);
		},
		emitMoveDataset(data: any) {
			this.emitSetDefaultMoveGroup();
			this.$emit("moveDataset", data);
		},
		emitRenameDataset(data?: any) {
			this.$emit("renameDataset", data);
		},
		emitSelect(data?: any) {
			this.$emit("select", data);
		},
		emitHighlight(data?: any) {
			this.$emit("highlight", data);
		},
		emitSetActiveDatasetType() {
			this.$emit("setActiveDatasetType", this.dataType);
		},
		emitSetActiveGroup() {
			this.$emit("setActiveGroup", this.groupName);
		},
		checkShowNameTooltip(event: MouseEvent): void {
			const datasetN: HTMLElement = event.target as HTMLElement;
			this.showFolderNameTruncatedTooltip = this.isFolderNameTruncated(datasetN);
		},
		isFolderNameTruncated(element: HTMLElement): boolean {
			return element.offsetWidth < element.scrollWidth;
		},
		selectRenameText(event: FocusEvent): void {
			this.newName = this.name; // reassign newName to avoid incorrect values on previously submitted errors
			(event?.target as HTMLInputElement)?.select();
		}
	},
	watch: {
		children: {
			deep: true,
			handler() {
				this.drawDashedBorders();
			}
		},
		showMenu(v) {
			if (v) {
				this.$nextTick(() => {
					setTimeout(() => {
						window.addEventListener(
							"mousedown",
							(this.closeOptionsMenuListener = () => {
								this.showMenu = false;
								window.removeEventListener(
									"mousedown",
									this.closeOptionsMenuListener
								);
							})
						);
					}, 100);
				});
			}
		},
		searchTerm(v) {
			if (v.length > 0) {
				this.isExpanded = true;
				this.$nextTick(() => {
					this.highlight(v);
				});
			} else {
				this.isExpanded = false;
			}
		}
	}
});
